export const GET_ADMINS = 'GET_ADMINS'
export const GET_ADMIN = 'GET_ADMIN'
export const GET_ADMIN_ASSESSMENTS = 'GET_ADMIN_ASSESSMENTS'
